import React from "react"

import { DateRangePicker } from "@/components/ui/date-range-picker"
import type { DateRange } from "@/types/trade"
import type {
  DashboardDatePresetTimeframe,
  DashboardDateRangeChangeOptions,
} from "@/utils/dashboardDateWindowStorage"

interface DashboardHeaderDateRangePickerProps {
  dateRange: DateRange
  onDateRangeChange: (
    dateRange: DateRange,
    options?: DashboardDateRangeChangeOptions
  ) => void
  selectedPresetId?: DashboardDatePresetTimeframe | null
  className?: string
  /** Pass `field` in form wizards so the trigger matches transparent selects. */
  triggerSurface?: "chrome" | "field"
  /** Override calendar columns (`1` or `2`). Default: `1` on mobile, `2` on desktop. */
  numberOfMonths?: 1 | 2
}

/**
 * Dashboard inset header date window — shadcn calendar + preset list.
 */
export function DashboardHeaderDateRangePicker({
  dateRange,
  onDateRangeChange,
  selectedPresetId = null,
  className,
  triggerSurface = "chrome",
  numberOfMonths,
}: DashboardHeaderDateRangePickerProps): React.ReactElement {
  return (
    <DateRangePicker
      dateRange={dateRange}
      onDateRangeChange={onDateRangeChange}
      selectedPresetId={selectedPresetId}
      emptyLabel="All time"
      className={className}
      triggerSurface={triggerSurface}
      {...(numberOfMonths != null ? { numberOfMonths } : {})}
    />
  )
}

export default DashboardHeaderDateRangePicker
